<template>
  <article class="facility-popup">
    <div class="facility-popup-title">
      <h5 class="text-18-600">
        {{ facilityPopupObject.name }}
      </h5>
      <IconButton icon="cross" @click="closePopup" />
    </div>
    <p
      v-if="facilityPopupObject.address"
      class="facility-popup-subtitle text-18-400"
    >
      {{ facilityPopupObject.address }}
    </p>
    <BaseButton @click="selectFacilityObject(facilityPopupObject)">
      {{ $t("More") }}
    </BaseButton>
  </article>
</template>

<script lang="ts">
import { PropType } from "vue";

import BaseButton from "~/components/button/BaseButton.vue";
import IconButton from "~/components/button/IconButton.vue";
import { ISupplierPreview } from "~/types/map.interface";

export default defineNuxtComponent({
  components: { IconButton, BaseButton },
  props: {
    facilityPopupObject: {
      type: Object as PropType<ISupplierPreview>,
      required: true,
    },
  },
  emits: ["close", "selectFacilityObject"],

  setup(_, { emit }) {
    function closePopup() {
      emit("close");
    }
    function selectFacilityObject(facility: ISupplierPreview) {
      emit("selectFacilityObject", facility);
    }
    return { closePopup, selectFacilityObject };
  },
});
</script>
